import 'ol/ol.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import {Provider} from 'react-redux';
import {Settings} from 'luxon';
import {loadFonts} from '@apps-common/ui-theme/Typography.js';

import './i18n.js';
import AppLayout from '@explorer/components/App.jsx';
import initSentry from './sentry.js';
import store from './store.js';

loadFonts();

// Polyfill for Windows
if (window !== undefined) {
  window.global = window;
}

// Ensure that all the blob support exists
if (Blob) {
  if (!Blob.prototype.text) {
    const reader = (blob, format) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = evt => {
          resolve(evt.target.result);
        };
        reader.onerror = () => {
          reject('Bad Blob');
        };
        if (format === 'text') {
          reader.readAsText(blob);
        } else {
          reader.readAsArrayBuffer(blob);
        }
      });
    };

    Blob.prototype.text = function () {
      return reader(this, 'text');
    };
    Blob.prototype.arrayBuffer = function () {
      return reader(this, 'arraybuffer');
    };
  }
}

// Setup Sentry
if (window.location.hostname === 'www.planet.com') {
  initSentry();
}

const root = ReactDOM.createRoot(document.getElementById('pl-root'));

root.render(
  <Provider store={store}>
    <AppLayout />
  </Provider>
);

// Set Luxon to use UTC by default
// We always use UTC dates and times when working with backend
// If you need to parse or generate a time for the user's system,
// use the zone `system` in your method calls (i.e. toFormat, fromISO, etc.)
// https://moment.github.io/luxon/#/zones?id=changing-the-default-zone
Settings.defaultZone = 'utc';
